import { create_div, wrap_element } from 'js/utils';

import './login_page.scss';

const settings = login_page_settings;

const login_form = document.querySelector('#loginform');
console.log('login_page', settings);

function init() {
	customize_input_username();
	customize_input_password();
	render_custom_html_top();
	render_logo();
	group_bottom_elements();
	customize_submit_button();
	customize_lost_password_link();
}
init();

function render_logo() {
	const img_url = settings.logo?.url;
	if (!img_url) return;

	const con = create_div('custom_logo');
	const img = document.createElement('img');
	img.src = img_url;
	con.append(img);

	// login_form.before(con);
	login_form.prepend(con);
}

function customize_input_username() {
	const input = document.querySelector('#user_login');
	if (!input) return;

	input.placeholder = 'Enter Username or Email Address';
	wrap_element(input.parentElement, 'username_input_con field_style_1');
}

function customize_input_password() {
	const input = document.querySelector('#user_pass');
	if (!input) return;

	input.placeholder = 'Enter Password';

	const con = document.querySelector('.user-pass-wrap');
	if (!con) return;

	con.classList.add('field_style_1');
}

function render_custom_html_top() {
	if (!settings.custom_html_top) return;

	const con = create_div('custom_html_top');
	login_form.prepend(con);

	con.innerHTML = settings.custom_html_top;
}

function group_bottom_elements() {
	const checkbox = document.querySelector('.forgetmenot');
	if (!checkbox) return;

	const submit_btn = document.querySelector('#loginform .submit');
	if (!submit_btn) return;

	const con = create_div('form_bottom_elements');
	con.id = 'form_bottom_elements';

	checkbox.before(con);
	con.append(checkbox);
	con.append(submit_btn);
}

function customize_submit_button() {
	const btn = document.querySelector('#wp-submit');
	if (!btn) return;
	btn.value = 'Login';
}

function customize_lost_password_link() {
	const el = document.querySelector('.wp-login-lost-password');
	if (!el) return;
	el.innerHTML = 'Forgot your password? <span>Reset Password</span>';
}
